/**
 * Shared ranking utilities used by Dashboard league cards and LeaguePage standings.
 * The same comparator must be applied everywhere so a tie produces the same order.
 *
 * Sort order: points DESC → exact DESC → user_id ASC
 */

export interface RankableRow {
  user_id: string;
  points: number;
  exact: number;
}

export const compareRankRows = (a: RankableRow, b: RankableRow): number =>
  b.points - a.points || b.exact - a.exact || a.user_id.localeCompare(b.user_id);

export const sortRanking = <T extends RankableRow>(rows: T[]): T[] =>
  [...rows].sort(compareRankRows);

/** Returns 1-based rank for `userId`. Returns 1 when user is not present. */
export const rankOf = (rows: RankableRow[], userId: string): number => {
  const sorted = sortRanking(rows);
  const idx = sorted.findIndex((r) => r.user_id === userId);
  return idx >= 0 ? idx + 1 : 1;
};
